import React from 'react';
import { formatVeraenderung, formatProz } from 'core/utils/format';

/**
 * Farbige Gewinn/Verlust-Anzeige (gruen bei >= 0, rot sonst). Zeigt den
 * absoluten Betrag mit Vorzeichen und optional die Prozent-Rendite.
 */
export default function GewinnBadge({ gv, gvProz, waehrung, gross = false }) {
  if (gv == null) return <span className="text-ink-muted">–</span>;
  const positiv = Number(gv) >= 0;
  const ton = positiv ? 'text-gain' : 'text-loss';
  return (
    <span className={`inline-flex items-baseline gap-1 tabular-nums ${ton} ${gross ? 'text-xl font-semibold' : 'text-sm font-medium'}`}>
      <span>{formatVeraenderung(gv, waehrung)}</span>
      {gvProz != null && <span className={gross ? 'text-sm' : 'text-xs'}>({formatProz(gvProz)})</span>}
    </span>
  );
}
